import { Image } from '@valbuild/next';
import { PageWidth } from '../../types/types';
import BlankImage from '../BlankImage/BlankImage';
import HotspotImage from './HotspotImage';

interface SingleImageElementProps {
  image: Image;
  size: PageWidth;
  keepAspectRatio?: boolean;
}

const SingleImageElement = ({
  image,
  size,
  keepAspectRatio = false,
}: SingleImageElementProps) => {
  if (keepAspectRatio) {
    return (
      <div className={`max-${size}-content w-full`}>
        <BlankImage src={image} width={1990} removeEffect />
      </div>
    );
  }
  return (
    <div
      className={`relative overflow-hidden h-[229px] laptop:h-[566px] w-full max-${size}-content`}
    >
      <HotspotImage image={image} />
    </div>
  );
};

export default SingleImageElement;
